






































































































































































import {Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import Menu from '@/menu/views/Menu.vue';
import LogoPostIt from '@/site/components/LogoPostIt.vue';
import SelectorSite from '@/site/components/SelectorSite.vue';

import AffluenceModal from '../components/AffluenceModal.vue';
import BaseService from '../components/BaseService.vue';

@Component({
  components: {
    Menu,
    SelectorSite,
    LogoPostIt,
    AffluenceModal,
  },
})
export default class Home extends BaseService {
  @Getter('motd', {namespace: 'site'}) motd!: string | null;

  @Getter('name', {namespace: 'site'}) siteName!: string;

  @Getter('slug', {namespace: 'site'}) slug!: string;

  @Getter('loading', {namespace: 'site'}) loading!: boolean;

  year = new Date().getFullYear();

  // @Getter('enableContact', {namespace: 'site'}) enableContact!: boolean;

  // @Getter('isBookingActivated', {namespace: 'site'}) isBookingActivated!: boolean;
}
